<template>
  <div class="upload-file" v-if="status">
    <div class="content">
      <div class="title">
        上传证据材料 <img @click="_close" class="click" src="../assets/icon_close.png" alt="">
      </div>
      <div class="info">
        <div class="upload">
          <input ref="file" type="file" accept="" style="display: none;" @change="_changeFile">
          <div><img v-if="img === ''" src="../assets/icon_camera.png" alt="" class="icon"> <img v-if="img !== '' && img.indexOf('pdf') === -1" :src="img" alt=""> <span v-if="img.indexOf('pdf') !== -1">已上传PDF</span></div>
          <span>支持png、jpg、pdf格式</span>
          <button class="click" @click="$refs.file.click()">选择文件</button>
        </div>
        <div class="from-item">
          <div class="t">材料重命名</div>
          <div class="input"><input type="text" v-model="param.fileName"></div>
        </div>
        <div class="from-item">
          <div class="t">描述</div>
          <div class="input"><textarea v-model="param.description"></textarea> </div>
        </div>
      </div>
      <div class="btn">
        <button class="click" @click="_upload">上传</button>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadFile, uploadCaseFile } from '@/service/getData'
export default {
  props: {
    id: {
      default: -1
    },
    userType: {
      default: -1
    },
    status: {
      default: false
    }
  },
  data () {
    return {
      img: '',
      param: {
        meetingId: -1,
        type: -1,
        fileName: '',
        filePath: '',
        description: ''
      }
    }
  },
  methods: {
    async _changeFile (e) {
      if (e.target.files.length > 0) {
        var file = e.target.files[0]
        if (file.type.indexOf('png') !== -1 || file.type.indexOf('jpg') !== -1 || file.type.indexOf('jpeg') !== -1 || file.type.indexOf('pdf') !== -1) {
          var res = await uploadFile({ file: file })
          if (res.code === 1) {
            this.param.filePath = res.data.filePath
            this.img = res.data.href
          }
        }
      }
    },
    _close () {
      this.$emit('handle', { type: 1, event: -1 })
    },
    async _upload () {
      var _this = this
      _this.param.meetingId = _this.id
      _this.param.type = _this.getTypeByUserType()
      if (_this.$verify.empty(_this.param.filePath)) { _this.$message.error('请选择要上传的文件'); return false }
      if (_this.$verify.empty(_this.param.fileName)) { _this.$message.error('请输入文件名称'); return false }
      if (_this.$verify.empty(_this.param.description)) { _this.$message.error('请输入文件描述'); return false }
      var res = await uploadCaseFile(_this.param)
      if (res.code === 1) {
        _this.$message.success('上传成功')
      } else {
        _this.$message.error(res.msg)
      }
      _this._close()
    },
    getTypeByUserType () {
      var userType = parseInt(this.userType)
      if (userType === 0 || userType === 5) {
        return 3
      } else {
        return 4
      }
    }
  }
}
</script>

<style lang="scss">
@import "../style/mixin";
.upload-file {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.3);
  .content {
    @include center;
    background-color: #fff;
    width: 5.417rem;
    border-radius: 0.042rem;
    overflow: hidden;
    button {
      background-color: #267CD0;
      color: #fff;
      padding: 0.01rem 0.108rem;
      border-radius: 0.25rem;
      margin: 0 0.1rem;
      font-size: 0.133rem;
      font-family: PingFang SC;
      font-weight: 500;
      color:rgba(255,255,255,1);
    }
    .from-item{
      margin-top: 0.175rem;
      .t {
        font-size: 0.133rem;
        font-family: PingFang SC;
        font-weight: 500;
        color:rgba(51,51,51,1);
        line-height: 0.4rem;
      }
      .input {
        border: 0.008rem solid #CCCCCC;
        border-radius: 0.042rem;
        padding: 0 0.1rem;
        input {
          width: 100%;
          line-height: 0.367rem;
        }
        textarea {
          resize: none;
          outline: 0 none !important;
          height: 1.083rem;
          width: 100%;
        }
      }
    }
    .upload {
      display: flex;
      align-items: flex-end;
      span {
        color: #999999;
        font-size: 0.117rem;
        font-family: PingFang SC;
        font-weight: 500;
        margin-left: 0.142rem;
        text-align: center;
      }
      button {
        margin-left: 0.142rem
      }
      &>div {
        @include wh(1.067rem, 1.067rem);
        position: relative;
        border: 0.017rem dashed #CCCCCC;
        span {
          @include center;
          margin-left: 0;
          font-family: PingFang SC;
          font-weight: 500;
        }
        img {
          @include wh(100%, 100%);
          &.icon {
            @include wh(0.367rem, 0.367rem);
            @include center;
          }
        }
      }
    }
    .btn {
      text-align: center;
      padding-bottom: 0.275rem;
      button {
        padding: 0.05rem 0.3rem;
      }
    }
    .info {
      padding: 0.333rem;
      &>div {
        font-size: 0.133rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #272727;
        line-height: 0.3rem;
      }
    }
    .title {
      height: 0.442rem;
      line-height: 0.442rem;
      font-size: 0.15rem;
      font-family:PingFang SC;
      font-weight:bold;
      text-align: center;
      background-color: #CDD8E7;
      position: relative;
      img {
        position: absolute;
        z-index: 2;
        right: 0.133rem;
        top: 0.125rem;
        @include wh(0.2rem, 0.2rem)
      }
    }
  }
}
</style>
